export enum PageType {
  ABOUT = 'about',
  HOME = 'home',
  PARTNERS = 'partners',
  PROJECTS = 'projects'
}
